export default (that) => [
  {
    text: that.$l('tips_view_document') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('tips_edit_document') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    show: ({ userPaymentRequestStatus }) => userPaymentRequestStatus === 'N' || userPaymentRequestStatus === 'R',
  },
  {
    text: that.$l('tips_delete_document') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    show: ({ userPaymentRequestStatus }) => userPaymentRequestStatus === 'N' || userPaymentRequestStatus === 'R',
  },
  {
    text: that.$l('tips_submit_oa_os_approval') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'approval',
    divided: true,
    allow: 'T',
    data: {},
    show: ({ userPaymentRequestStatus }) => userPaymentRequestStatus === 'N' || userPaymentRequestStatus === 'R',
  },
  {
    text: that.$l('tips_rejected') || '强制驳回',
    icon: 'el-icon-refresh-left',
    menuType: 'rejected',
    divided: true,
    allow: 'R',
    data: {},
    show: ({ userPaymentRequestStatus }) => userPaymentRequestStatus === 'Y',
  }
]
